import React from 'react';
import { AppStore } from '../../AppStore';
import { Pathword5x5Store } from '../_puzzles/Pathword5x5/Pathword5x5Store';
import StarIcon from '@mui/icons-material/Star';
import OutcomeBanner from './OutcomeBanner';

const Pathword5x5Preview = ({ onClick }: { onClick: () => void }) => {
  const pathword5x5Data = AppStore.useState(s => s.puzzleData?.pathword5x5);
  if (!pathword5x5Data) return null;

  const matrix = pathword5x5Data.vowelMatrix;

  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="puzzleTitle">Pathword 5x5</div>
      <div className="matrixPreviewContainer">
        <div className="matrixGrid">
          <div className="goldStar"><StarIcon/></div>
          {matrix.map((row, rowIndex) => (
            <div key={rowIndex} className="matrixRow">
              {row.map((letter, columnIndex) => (
                <div className={`previewGridCell ${letter ? '' : 'grey'}`} key={columnIndex}/>
              ))}
            </div>
          ))}
        </div>
        <OutcomeBanner store={Pathword5x5Store as any}/>
      </div>
    </div>
  );
};

export default Pathword5x5Preview;